module.exports = __webpack_public_path__ + "cf7fb37b1d3fcb455a7d38827cfc17d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slideshow/13.jpg
// module id = 283
// module chunks = 0